import * as React from 'react';

import  { withStyles } from '@mui/styles';

import {WithStyles, StyleRules} from '@mui/styles';

import { 
  PredefinedField
} from '../lib/types';
import {Theme} from '@mui/styles';
import {Typography, TextField, Button, IconButton} from '@mui/material';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  },
  sectionTitle: {
    fontSize:"1rem"
  },
  instructions: {
    padding:15
  },
  formArea: {
    padding: 15
  }, 
  formField: {
    width: "40%"
  },
  fieldRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between"
  },
  actionBar: {
    display: "flex",
    justifyContent: "flex-end"
  },
  itemDelete: {
    fontSize: "0.80rem",
    width: 45,
    height: 45
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  field: PredefinedField;
  onOptionsChange: (newOptions: Array<any>) => void;
}

// We will kepp internal state to give more options to the consumers, but we will always defer to the data coming from the props.
type State = {
  options: any;
};

class OptionsView extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      options: this.props.field.options || []
    };
  }

  UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>, oldProps: Props & WithStyles<keyof typeof styles>) {
    // When we get new props, always defer to those over internal state.  This is crucial to the predictable operation of the component parts
    // Initiate loading here is any loading is required.  Do not forget to also implement incomponentDidMount also 
    this.setState({options:newProps.field.options || []})
  }

  handleAttributeChange = (idx:number) => (attribute:string) => (evt:any) => {
    const { options } = this.state
    options[idx][attribute] = evt.target.value
    this.setState({options})
    if(this.props.onOptionsChange){
      this.props.onOptionsChange(options)
    }
  }

  handleItemDelete = (idx:number) => (evt:any) => {
    const { options } = this.state
    var newOptions: Array<any> = options.filter(function(value, arrIndex) {
      return idx !== arrIndex;
    });
    this.setState({options:newOptions})
    if(this.props.onOptionsChange){
      this.props.onOptionsChange(newOptions)
    }
  }

  handleItemAdd = (evt:any) => {
    const { options } = this.state
    options.push({})
    this.setState({options})
    if(this.props.onOptionsChange){
      this.props.onOptionsChange(options)
    }
  }

  
  render() {
    const {classes}: {classes: any} = this.props;
    const {options} = this.state



    let optionsArea:any = null
    if(options && options.length > 0){

      optionsArea = options.map((option:any, idx:any)=>{
        return (
          <div key={idx} className={classes.fieldRow}>
            <TextField
              className={classes.formField}
              id="label"
              name="label"
              value={option.label || ''}
              label="label"
              onChange={this.handleAttributeChange(idx)('label')}
              InputLabelProps={{
                shrink: true
              }}
            />
            <TextField
              className={classes.formField}
              id="value"
              name="value"
              value={option.value || ''}
              label="value"
              onChange={this.handleAttributeChange(idx)('value')}
              InputLabelProps={{
                shrink: true
              }}
            />
            <IconButton  size="large" aria-label="delete" className={classes.itemDelete} onClick={this.handleItemDelete(idx)}>
               <i className="fa fas fa-trash"/>
            </IconButton>
          </div>
        )
      })
    } else {
      optionsArea =  <Typography variant="body1">No options have been specified</Typography>
    }

    return (
      <div className={classes.container}>
        {optionsArea}
        <div className={classes.actionBar}>
          <Button color="primary" className={classes.button} onClick={this.handleItemAdd}>
            Add
          </Button>
        </div>
      </div>
    );

  }
}

export default withStyles(styles)(OptionsView);

